import { ArrowDown } from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { FIN, euro, clampAmount as clamp } from "@/content/financing";

const Row = ({ label, value, testid }) => (
  <div className="flex items-baseline justify-between gap-4 py-3 border-b border-[#FCFBF7]/10 last:border-0">
    <span className="text-sm text-[#FCFBF7]/70">{label}</span>
    <span className="f-mono text-sm text-[#FCFBF7]" data-testid={testid}>{value}</span>
  </div>
);

export const Simulator = ({ amount, setAmount, rate, setRate, onUse }) => (

    <div className="rounded-[2rem] bg-[#0F2317] text-[#FCFBF7] p-6 sm:p-10 grid lg:grid-cols-12 gap-10" data-testid="financing-simulator">
      <div className="lg:col-span-7 space-y-10">
        <div>
          <div className="flex items-center justify-between gap-4">
            <label htmlFor="fin-amount" className="eyebrow text-[#86C89B]">Importo del preventivo</label>
            <div className="flex items-center gap-1 rounded-full border border-[#FCFBF7]/20 pl-4 pr-3 py-1.5 focus-within:border-[#86C89B]">
              <input id="fin-amount" type="number" inputMode="numeric" min={FIN.min} max={FIN.max} value={amount}
                onChange={(e) => setAmount(Number(e.target.value) || 0)} onBlur={() => setAmount(clamp(amount))}
                className="w-20 bg-transparent text-right f-mono text-base outline-none" data-testid="financing-amount-input" />
              <span className="text-[#FCFBF7]/70">€</span>
            </div>
          </div>
          <Slider value={[clamp(amount)]} onValueChange={([v]) => setAmount(v)} min={FIN.min} max={FIN.max} step={50} className="mt-6 fin-slider" data-testid="financing-amount-slider" />
          <div className="flex justify-between text-xs text-[#FCFBF7]/60 mt-3 f-mono"><span>{euro(FIN.min, 0)}</span><span>{euro(FIN.max, 0)}</span></div>
        </div>
        <div>
          <div className="flex items-center justify-between gap-4">
            <span className="eyebrow text-[#86C89B]">Numero di rate</span>
            <span className="f-serif text-3xl" data-testid="financing-rate-value">{rate} <em className="text-[#86C89B] text-xl">mesi</em></span>
          </div>
          <Slider value={[rate]} onValueChange={([v]) => setRate(v)} min={FIN.minRate} max={FIN.maxRate} step={1} className="mt-6 fin-slider" data-testid="financing-rate-slider" />
          <div className="flex justify-between text-xs text-[#FCFBF7]/60 mt-3 f-mono"><span>{FIN.minRate} rate</span><span>{FIN.maxRate} rate</span></div>
          <div className="mt-8 flex flex-wrap items-center gap-2">
            <span className="text-xs text-[#FCFBF7]/70 mr-1">Scelte rapide</span>
            {[6, 10, 12, 18, 24].map((n) => (
              <button type="button" key={n} onClick={() => setRate(n)} data-testid={`financing-rate-preset-${n}`}
                className={`rounded-full px-4 py-2 text-sm border transition-colors ${rate === n ? "bg-[#86C89B] border-[#86C89B] text-[#0F2317]" : "border-[#FCFBF7]/20 text-[#FCFBF7] hover:border-[#86C89B]"}`}>
                {n} rate
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="lg:col-span-5 rounded-3xl bg-[#FCFBF7]/[0.05] border border-[#FCFBF7]/10 p-6 sm:p-8 flex flex-col">
        <span className="eyebrow text-[#86C89B]">La tua rata mensile</span>
        <p className="f-serif text-6xl sm:text-7xl leading-none mt-4 tabular-nums" data-testid="financing-monthly">{euro(clamp(amount) / rate)}</p>
        <p className="text-sm text-[#FCFBF7]/70 mt-3">per {rate} mesi, senza interessi</p>
        <div className="mt-8">
          <Row label="Importo finanziato" value={euro(clamp(amount))} testid="financing-total" />
          <Row label="TAN" value="0,00%" testid="financing-tan" />
          <Row label="TAEG" value="0,00%" testid="financing-taeg" />
          <Row label="Interessi" value={euro(0)} testid="financing-interest" />
        </div>
        <button type="button" onClick={onUse} data-testid="financing-use-btn"
          className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-[#86C89B] text-[#0F2317] px-6 py-3.5 text-sm font-medium hover:bg-[#FCFBF7] transition-colors">
          <span className="sm:hidden">Invia il preventivo</span><span className="hidden sm:inline">Invia il preventivo con questa rata</span> <ArrowDown size={15} />
        </button>
      </div>
    </div>
);
